import DownloadInvoiceModal from '@components/modals/DownloadInvoiceModal.vue'

export default {
  components: {
    DownloadPayoutModal: DownloadInvoiceModal
  },
  data () {
    return {
      downloadPayoutModal: {
        show: false,
        payout: null,
        triggerElement: null
      }
    }
  },
  methods: {
    showDownloadPayoutModal (data) {
      this.downloadPayoutModal.payout = data.payout
      this.downloadPayoutModal.triggerElement = data.triggerElement
      this.downloadPayoutModal.show = true
    },
    getAvailableTemplates () {
      if (!this.getPayoutsTemplateTypes || !this.downloadPayoutModal.payout) {
        return []
      }

      return this.getPayoutsTemplateTypes.filter(({ name }) => {
        const payout = this.downloadPayoutModal.payout
        /**
         * If payout has `payout_template_type` property set to "custom" and `custom_file_name` property (that is the
         * custom template is uploaded) then we need to display only that custom template. Otherwise, we should not
         * display custom template.
         */
        if (payout.payout_template_type?.name === 'custom' && payout.custom_file_name) {
          return name === 'custom'
        } else {
          return name !== 'custom'
        }
      })
    }
  }
}
